export const makeFieldUpdater = (setCharacter, field) => value =>
  setCharacter(prev => ({ ...prev, [field]: value }));

export const applyCurrentHealth = (prev, newCurrentHealth) => {
  const dead = newCurrentHealth <= prev.deathThreshold;
  return { ...prev, currentHealth: newCurrentHealth, isDead: dead };
};

export const applyTotalHealth = (prev, newTotalHealth) => {
  const threshold = Math.ceil(newTotalHealth * 0.25) * -1;
  return { ...prev, totalHealth: newTotalHealth, deathThreshold: threshold };
};

export const applyTraitValue = (prev, name, value) => ({
  ...prev,
  traits: { ...prev.traits, [name]: value },
});
